import { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Badge } from "@/components/ui/badge";
import { BaseAreaFields, CapabilityPicker } from "@/components/LeadFields";
import { Radar, Loader2 } from "lucide-react";
import { toast } from "sonner";

const EMPTY = { suburb: "", state: "", postcode: "", lat: null, lng: null, max_service_radius_km: 50, is_interstate_capable: false, capabilities: [], enabled: true };

const fromListing = (l) => ({
  suburb: l.suburb, state: l.state, postcode: l.postcode, lat: l.base_location.coordinates[1], lng: l.base_location.coordinates[0],
  max_service_radius_km: l.max_service_radius_km, is_interstate_capable: l.is_interstate_capable, capabilities: l.capabilities || [],
  enabled: l.approved_for_leads !== false,
});

export function LeadAreaCard() {
  const [v, setV] = useState(null);
  const [opts, setOpts] = useState([]);
  const [listing, setListing] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    api.get("/removalist/lead-area").then(({ data }) => {
      setOpts(data.capability_options); setListing(data.listing); setV(data.listing ? fromListing(data.listing) : EMPTY);
    }).catch(() => setV(EMPTY));
  }, []);
  const save = async () => {
    if (!v.postcode) { toast.error("Pick your base suburb first"); return; }
    setSaving(true);
    try {
      const { data } = await api.put("/removalist/lead-area", v);
      setListing(data.listing); toast.success("Instant lead area saved");
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); } finally { setSaving(false); }
  };
  if (!v) return null;
  return (
    <Card className="p-6 space-y-5 mb-6" data-testid="lead-area-card">
      <div className="flex items-start justify-between gap-3">
        <div>
          <h2 className="font-display font-bold text-lg flex items-center gap-2"><Radar className="h-5 w-5 text-kinetic" /> Instant lead emails</h2>
          <p className="text-sm text-muted-foreground">Get an email the moment a customer posts a move within your radius of your base.</p>
        </div>
        {listing && <Badge variant="outline" data-testid="lead-area-status">{listing.claim_status}</Badge>}
      </div>
      <BaseAreaFields v={v} set={setV} />
      <div className="space-y-2"><Label>Services you offer</Label><CapabilityPicker options={opts} value={v.capabilities} onChange={(c) => setV({ ...v, capabilities: c })} prefix="lead-cap" /></div>
      <label className="flex items-center gap-3 text-sm">
        <Switch checked={v.enabled} onCheckedChange={(c) => setV({ ...v, enabled: c })} data-testid="lead-area-enabled-switch" /> Send me instant lead emails
      </label>
      <Button onClick={save} disabled={saving} className="bg-kinetic hover:bg-kinetic-hover text-white" data-testid="lead-area-save-btn">
        {saving && <Loader2 className="h-4 w-4 animate-spin mr-2" />} Save lead area
      </Button>
    </Card>
  );
}
